export default __webpack_public_path__ + "static/media/macchiato.1ee2c85d.png";